module.exports = __webpack_public_path__ + "static/img/slsPurpose3.6fca305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slsPurpose3.png
// module id = aawA
// module chunks = 2